import { render, staticRenderFns } from "./Taiga.vue?vue&type=template&id=5bec77ea&scoped=true&"
import script from "./Taiga.vue?vue&type=script&lang=js&"
export * from "./Taiga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec77ea",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BButton, BTable, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BButton, BTable, BContainer})
    

export default component.exports